// src/broadcast/components/BroadcastDebug.tsx
"use client"

import { useBroadcast } from '../providers/BroadcastProvider'
import { useBroadcastStore } from '../stores/useBroadcastStore'

/**
 * Debug component for broadcast connection status
 * Only render in development mode
 */
export function BroadcastDebug() {
  const { isConnected, error, channelState, userId } = useBroadcast()
  const messageCount = useBroadcastStore((s) => s.messages.size)
  const lastEvent = useBroadcastStore((s) => s.lastEventTimestamp)

  if (process.env.NODE_ENV !== 'development') {
    return null
  }

  return (
    <div className="fixed bottom-4 right-4 p-4 bg-black/80 text-white text-xs rounded-lg font-mono z-50">
      <div className="font-bold mb-2">Broadcast Debug</div>
      <div>User: {userId ?? 'Not logged in'}</div>
      <div>
        Status:
        <span className={isConnected ? 'text-green-400' : 'text-red-400'}>
          {' '}{isConnected ? 'Connected' : 'Disconnected'}
        </span>
      </div>
      <div>Channel: {channelState}</div>
      <div>Messages: {messageCount}</div>
      <div>Last Event: {lastEvent ? new Date(lastEvent).toLocaleTimeString() : 'None'}</div>
      {error && <div className="text-red-400">Error: {error.message}</div>}
    </div>
  )
}
